@if (initialized) {
  <forge-select #select [formControl]="formControl" [label]="labelText" [required]="isRequired" [invalid]="isInvalid"
    density="small">
    @if (loadingSpinner) {
      <forge-circular-progress slot="start" diameter="24">
      </forge-circular-progress>
    }
    @for (option of options; track option) {
      <forge-option [value]="getValue(option)">
        {{ getDisplayValue(option) }}
      </forge-option>
    }
    @if(!suppressSupportText)
      {
      <span slot="support-text">
        @if (showErrorMessage('required')) {
          {{label}} is required
        }
        @if (hasCustomValidators) {
          @for (customError of customErrors; track customError) {
            @if (hasError(customError)) {
              {{customError.message}}
            }
          }
        }
      </span>
    }
  </forge-select>
}